import moment from "moment";

export function getSurveyDateFormat(dateFormat) {
  return dateFormat === "Year" ? "YYYY" : dateFormat === "Month" ? "MM/YYYY" : "DD.MM.YYYY";
}

export function parseSurveyDate(value) {
  if (!value) return moment.invalid();

  // Older CSV imports stored the entered two-digit year in an ISO-like timestamp.
  // Use Moment's existing two-digit-year convention, also used for CSV input.
  if (typeof value === "string" && /^\d{2}-\d{2}-\d{2}T/.test(value)) {
    return moment.utc(value, "YY-MM-DD[T]HH:mm:ss.SSS[Z]", true);
  }

  return moment.utc(value, moment.ISO_8601, true);
}

export function parseImportedSurveyDate(value, dateFormat) {
  if (!value) return moment.invalid();

  const formats = dateFormat === "Year"
    ? ["YYYY", "YY"]
    : dateFormat === "Month"
    ? ["MM/YYYY", "MM/YY", "M/YYYY", "M/YY"]
    : ["DD.MM", "D.M", "DD.M", "D.MM", "DD/MM", "D/M", "DD/M", "D/MM"]
      .flatMap(format => [format + (format.includes(".") ? ".YYYY" : "/YYYY"),
        format + (format.includes(".") ? ".YY" : "/YY")]);

  return moment.utc(value.trim(), formats, true);
}
